import React, { useEffect, useState } from 'react';
import Page from '../../../components/Page';
import useSettings from '../../../hooks/useSettings';
import { PATH_DASHBOARD } from '../../../routes/paths';
import { dispatch, useSelector } from '../../../redux/store';
import { capitalize } from '../../../utils/common';
import DataGridTable from '../../../components/table/DataGridTable';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import {
  getGuestsForRevenueReport,
} from '../../../redux/slices/guestRedux/guestRedux';
import {
  Container
} from '@mui/material';
import { FOOD_CATEGORIES, PAYMENT_OPTIONS } from '../../../utils/constants';

export default function GuestRevenueReport() {
  const pageName = 'Guest Revenue Report';
  const { themeStretch } = useSettings();
  const [guestList, setGuestList] = useState([]);
  const [rowSelection, setRowSelection] = useState(false);
  const { data } = useSelector((state) => state?.guest);

  useEffect(() => {
    dispatch(getGuestsForRevenueReport());
  }, []);

  useEffect(() => {
    const updatedGuestList = data?.map((value) => {

      const totalAmountBeforeTax = (value?.billing?.reduce((sum, item) => sum + item.amount, 0) || 0).toFixed(2);
      const totalGovTax = (totalAmountBeforeTax * 0.025).toFixed(2);
      const totalAmount = (parseFloat(totalAmountBeforeTax) + parseFloat(totalGovTax)).toFixed(2);
      const paidAmount = (value?.payments?.reduce((sum, payment) => sum + payment.amount, 0) || 0).toFixed(2);
      const balanceAmount = (parseFloat(totalAmount) - parseFloat(paidAmount)).toFixed(2);

      const categorySums = FOOD_CATEGORIES.reduce((acc, category) => {
        acc[category.value] = 0;
        return acc;
      }, {});

      const paymentTypes = PAYMENT_OPTIONS.reduce((acc, paymentType) => {
        acc[paymentType] = 0;
        return acc;
      }, {});

      value?.billing?.forEach((billing) => {
        categorySums[billing?.category] += billing?.amount
      });

      value?.payments?.forEach((payments) => {
        paymentTypes[payments?.paymentType] += payments?.amount
      });

      Object.keys(categorySums).forEach(key => {
        categorySums[key] = categorySums[key].toFixed(2);
      });

      Object.keys(paymentTypes).forEach(key => {
        paymentTypes[key] = paymentTypes[key].toFixed(2);
      });

      return {
        checkInDate: value?.checkInDate,
        name: value?.name,
        ...categorySums,
        totalAmountBeforeTax,
        totalGovTax,
        totalAmount,
        paidAmount,
        ...paymentTypes,
        balanceAmount,
      };
    });


    setGuestList(updatedGuestList);
  }, [data]);


  const columns = !guestList?.[0]
    ? []
    : Object.keys(guestList?.[0])
        .map((value) => {
          if (['guestCard','user','log', 'userId', 'guestCardId', 'billing', 'payments'].includes(value)) {
            return {};
          } else {
            return {
              accessorKey: value,
              header: capitalize(value),
            };
          }
        })
        ?.filter((value) => value?.accessorKey);


  return (
    <Page title={`${pageName}`}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={`${pageName}`}
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            {
              name: 'Product',
              href: '',
            },
            { name: `${pageName}` },
          ]}
          action={ <></>}
        />

        <DataGridTable
          name={`${pageName} List`}
          data={guestList}
          column={columns}
          isRowClickable={false}
          isLoading={false}
          rowSelection={rowSelection}
          setRowSelection={setRowSelection}
          enableRowSelection={true}
          enableRowActions={false}
          enablePinning={false}
        />
      </Container>
    </Page>
  );
}
